export const TECHNICAL_SUPPORT_FILTER_FORM_ID = 'technical-support-filter-form';
